export default {"src":"https://fishbrain.com/_next/static/media/maine.85eb0e5b.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};